<template>
  <div class="filter">
    <p class="type">
      {{ title }}
    </p>
    <div
      v-if="$slots.default"
      class="filter-content"
    >
      <slot />
    </div>
    <div
      v-else
      :class="{ 'row-wrap': useRowWrap }"
    >
      <div
        v-for="(option, index) in options"
        :key="index"
        class="filter-option"
      >
        <checkbox-item
          :label="option.label"
          :checked="isChecked(option)"
          @change="handleOptionChange(option)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { isValueSelected } from '@/views/apps/retailer-ai/utils'
import CheckboxItem from './CheckboxItem.vue'

export default {
  name: 'FilterGroup',
  components: {
    CheckboxItem,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    options: {
      type: Array,
      default: () => [],
      required: false,
    },
    selectedValues: {
      type: Array,
      default: () => [],
    },
    useRowWrap: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['change'],
  methods: {
    isChecked(option) {
      return isValueSelected(option.value, this.selectedValues)
    },
    handleOptionChange(option) {
      this.$emit('change', option)
    },
  },
}
</script>

<style scoped>
.filter {
  font-size: 14px;
  line-height: 21px;
  width: 100%;
  margin-bottom: 16px;
}

.type {
  font-weight: 700;
  margin-bottom: 4px;
}

.filter-option {
  margin-bottom: 4px;
}

.row-wrap {
  display: flex;
  justify-content: space-between;
  max-width: 90%;
  flex-wrap: wrap;
  gap: 8px;
}

.row-wrap .filter-option {
  width: 110px;
}
</style>
